// Gather deferred objects (e.g. server requests) to determine visibility of a "Loading" message
(function () {

	window.lp = window.lp || {};

	lp.LoadingIndicator = function (options) {

		options = options || {};
		return {
			count: 0,
			config: {
				// DEFAULTS
				graceTime: 2500,
				message: 'Please wait while we update the page.',
				severeTime: 10000,
				severeMessage: '',
				killTime: 60000,
				killMessage: '',
				killMessageTime: 10000,
				htmlID: 'loadingIndicatorDefault'
			},
			htmlTemplate (message) {

				return `
				<div id="${this.config.htmlID}" class="loadingIndicatorWrapper loadingIndicator hidden">
					<span class="spinner lpIcon-loading"></span>
					<div>
						<div class="loadingIndicatorTitle">Loading...</div>
						<div id="${this.config.htmlID}Message">${message}</div>
					</div>
				</div>
				`;

			},
			initialize () {

				this.config = {
					...this.config,
					...options
				};
				this.currentMessage = this.config.message;

				$('body').prepend(this.htmlTemplate(this.currentMessage));
				this.$parentEl = $(`#${this.config.htmlID}`);
				this.$messageEl = $(`#${this.config.htmlID}Message`);

			},
			showIndicator () {

				this.$parentEl.removeClass('hidden');

				if (this.config.severeMessage) {

					this.severeTimeout = setTimeout(() => {

						this.showSevereMessage();

					}, this.config.severeTime);

				}

				this.killTimeout = setTimeout(() => {

					if (this.config.killMessage) {

						this.showKillMessage();
						this.killMessageTimeout = setTimeout(() => {

							this.hideIndicator();

						}, this.config.killMessageTime);

					} else {

						this.hideIndicator();

					}

				}, this.config.killTime);

			},
			hideIndicator () {

				this.$parentEl.addClass('hidden');

				clearTimeout(this.graceTimeout);
				clearTimeout(this.severeTimeout);
				clearTimeout(this.killTimeout);
				clearTimeout(this.killMessageTimeout);

			},
			pushDeferred (event, $deferred) {

				if (this.count < 1) {

					this.graceTimeout = setTimeout(() => {

						this.showIndicator();

					}, this.config.graceTime);

				}

				this.count += 1;

				// Support for receiving a native promise
				if ($deferred.finally) {

					$deferred.finally(() => {

						this.count -= 1;
						if (this.count < 1) {

							this.hideIndicator();

						}

					});

				} else {

					$deferred.always(() => {

						this.count -= 1;
						if (this.count < 1) {

							this.hideIndicator();

						}

					});

				}

			},
			showSevereMessage () {

				this.currentMessage = this.config.severeMessage;
				this.$messageEl.html(this.currentMessage);

			},
			showKillMessage () {

				this.currentMessage = this.config.killMessage;
				this.$messageEl.html(this.currentMessage);

			}
		};

	};

}());
